import { defineComponent as _defineComponent } from 'vue'
import Badge from '@/components/atoms/badge/Badge.vue';
import Dropdown from '@/components/molecules/dropdown/Dropdown.vue';
import { Cell } from './types';

export interface TableRowProps {
    cells: Cell[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableRow',
  props: {
    cells: null
  },
  setup(__props: any) {



const getClasses = (isLast: boolean) => {
    return `card-col ${isLast ? 'row-end' : ''}`;
};

return { __sfc: true,getClasses, Badge, Dropdown }
}

})